export default __webpack_public_path__ + "static/media/product-14 (2).fc5ee5fb.jpg";